/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'underscore',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../util/TransactionUtil',
	'./FilterLabelHelper',
	'../../../lib/@waca/dashboard-common/dist/utils/FlyoutContentBase',
	'doT',
	'text!./FilterList.html',
	'../../../lib/@waca/core-client/js/core-client/utils/Utils',
	'../../../util/KeyCodes'
], function($, _, stringResources, TransactionUtil, FilterLabelHelper, FlyoutContentBase, dot, FilterListTemplate, Utils, KeyCodes) {
	'use strict';

	var filterTemplate = dot.template(FilterListTemplate);

	const FilterFlyoutView = FlyoutContentBase.extend({

		init: function(options) {
			FilterFlyoutView.inherited('init', this, arguments);
			this.visAPI = options.viewOptions.visAPI;
			this.config = options.viewOptions.config;
			this.visController = options.viewOptions.visController;
			this.transaction = options.viewOptions.transaction;
			this.visualization = options.viewOptions.visualization;

			const dataSource = this.visualization.getDataSource();
			this._filterLabelHelper = new FilterLabelHelper({ dataSource: dataSource, visAPI: this.visAPI });

			this.visAPI.ownerWidget.model.on('change:localFilters', this._updateFilterLabels, this);

			this.popOver = null;
			this.logger = options.logger;
			this.iconsFeature = this.visAPI.ownerWidget.getDashboardApi().getFeature('Icons');
			this.addIcon = this.iconsFeature.getIcon('addNew');
			this.editIcon = this.iconsFeature.getIcon('common-edit');
		},

		destroy: function() {
			this.visAPI.ownerWidget.model.off('change:localFilters', this._updateFilterLabels, this);
		},

		_getFilterId: function(event) {
			var filterEntry = $(event.target).parents('.filterEntry')[0] || $(event.target)[0];
			if (filterEntry) {
				return filterEntry.getAttribute('data-id');
			}
			return null;
		},

		setFocus: function() {
			this.popOver = $('.filterPopover');
			this.popOver.find('li:first-Child').focus();
		},

		_onKeyUp: function(event) {
			if (event.keyCode === KeyCodes.KEY_DELETE || event.keyCode === KeyCodes.KEY_DELETE_MAC) {
				this.onRemoveContextFilter(event);
			}
		},

		//@override
		onPopupShown: function() {
			this.onPopupClosed(); // reset because it gets called multiple times, otherwise will register handler multiple times
			var $sel = $('.filterPopover');

			$sel = Utils.embedSVGIcon($sel);

			$sel.on('primaryaction', '.filterDelete', null, this.onRemoveContextFilter.bind(this));
			$sel.on('primaryaction', '.localFilterList .visTopCapsule.filterEntry .filterLineContent.filterSelector, .localFilterList .visTopCapsule.filterEntry .filterEdit, .localFilterList li.visTopCapsule.filterEntry', null, this.onEditContextFilter.bind(this));
			$sel.on('keyup', '.visTopCapsule.filterEntry', null, this._onKeyUp.bind(this));

			$sel.on('primaryaction', '.topBottomDelete', null, this.onRemoveContextTopBottom.bind(this));
			$sel.on('primaryaction', '.visTopCapsule.topBottomEntry, .filterLineContent.topBottomSelector, .topBottomEdit', null, this.onEditContextTopBottom.bind(this));
			$sel.on('deleteaction', '.visTopCapsule.topBottomEntry', null, this.onRemoveContextTopBottom.bind(this));

			$sel.on('primaryaction', '.visTopCapsule.promptEntry, .filterLineContent.promptSelector, .promptEdit', null, this.onEditPrompt.bind(this));

			$sel.on('primaryaction', '.drillStateDelete', null, this.onRemoveContextDrill.bind(this));
		},

		//@override
		onPopupClosed: function() {
			var $sel = $('.filterPopover');
			$sel.off();
		},

		onEditPrompt: function(event) {
			event.stopPropagation();
			var node = $(event.target).parents('.promptEntry')[0] || $(event.target)[0];
			var sPromptName = node.getAttribute('data-id');
			if (!sPromptName) {
				this.logger.error('Could not find prompt info to edit', event);
				return false;
			}

			this.visAPI.ownerWidget.rePrompt(sPromptName);
			this.popupParent.close();

			return false;
		},

		onEditContextFilter: function(event) {
			event.stopPropagation();

			//The data-id attribute holds the filter collection model id for the filters model to be edited
			var filterToEdit = this._getFilterId(event);
			this._currentFilterId = filterToEdit;
			var node = $(event.target).parents('.filterEntry')[0] || $(event.target)[0];
			return this.visController
				.getActionHelper()
				.editLocalFilter(filterToEdit, node)
				.then((editor) => {
					if (editor) {
						this.popupParent.detachHideEvents(); // stay visible while editor active
						this.parentListClass = '.filterList';
					}
				});
		},

		/**
		 * refresh the values for the filters displayed in the list
		 */
		_updateFilterLabels: function() {
			var filters = this.visAPI.getFilterInfo();
			_.each(filters.localFilters, function(filter) {
				if (filter.id === this._currentFilterId) {
					var $sel = $('.filterEntry[data-id="' + filter.id + '"] .filterSummary');
					var desc = this._filterLabelHelper.getFilterDescription(filter);
					if (!desc) {
						desc = '';
					}
					$sel.text(desc);
					$sel.attr('title', desc);
					return;
				}
			}.bind(this));
		},

		/**
		 * Handler for click of a delete button on any filter list entry.
		 * @param event with the div which represents the delete button.
		 */
		onRemoveContextFilter: function(event) {
			event.stopPropagation();
			//The data-id attribute holds the filter collection model id for the filters model to be deleted
			var filterToDelete = this._getFilterId(event);
			if (filterToDelete) {
				this.visAPI.localFilters.removeFilterEntry({
					id: filterToDelete
				});
				this.visAPI.localFilters.allFilterModificationComplete();
				var payload = {
					filterToDelete: filterToDelete,
					pageContext: this.visAPI.getPageContextAPI()
				};
				this.visAPI.ownerWidget.getDashboardApi().triggerDashboardEvent('filterIndicator:removeEntry', payload);
			}
			this.popupParent.close();
		},

		getRenderedHtml: function() {
			var filters = this.visAPI.getFilterInfo();
			var topBottoms = this.visAPI.getTopBottomInfo();
			var drillState = this.visAPI.getDrillInfo();

			var bHasLocalFilters = this.config.localFilters && filters.localFilters.length > 0;
			var bHasLocalTopBottom = this.config.localTopbottoms && topBottoms.length > 0;
			var bHasLocalDrill = this.config.drillState && drillState.length > 0;
			var oPromptSpec = this.visAPI.getPromptSpec();

			var markup = '';

			if (bHasLocalFilters || bHasLocalTopBottom || bHasLocalDrill || oPromptSpec) {
				var aListItems = [];
				if (bHasLocalFilters) {
					aListItems = aListItems.concat(this._filterLabelHelper.generateFilterListItems(filters.localFilters));
				}

				if (bHasLocalTopBottom) {
					aListItems = aListItems.concat(this._filterLabelHelper.generateTopBottomListItems(topBottoms));
				}

				if(bHasLocalDrill) {
					this._generateDrillStateListItems(drillState, aListItems);
				}

				if (oPromptSpec) {
					this._generatePromptListItems(oPromptSpec, aListItems);
				}

				markup += filterTemplate({
					'title': stringResources.get('localFilterTitle'),
					'className': 'localFilterList',
					'lines': aListItems,
					'addIcon': this.addIcon.id,
					'editIcon': this.editIcon.id
				});
			}

			if (this.config.globalFilters && filters.filters.length > 0) {
				var aGlobalList = [];
				aGlobalList = this._filterLabelHelper.generateFilterListItems(filters.filters);
				markup += filterTemplate({
					'title': stringResources.get('globalFilterTitle'),
					'className': 'globalFilterList',
					'lines': aGlobalList,
					'addIcon': this.addIcon.id,
					'editIcon': this.editIcon.id
				});
			}

			return markup;
		},

		onRemoveContextTopBottom: function(event) {
			event.stopPropagation();
			//The data-id attribute holds the topBottom collection model id for the topBottom model to be deleted
			var topBottomToDelete = this._getTopBottomId(event);
			if (topBottomToDelete) {
				const mappingInfo = this.visualization.getSlots().getMappingInfo(topBottomToDelete);
				var slot = mappingInfo.slot;
				var index = mappingInfo.indexInSlot;

				if (slot && index >= 0) {
					const topBottomAction = this.visAPI.ownerWidget.content.getFeature('topBottomAction');
					topBottomAction.reset(slot.getId(), index);
					this.popupParent.close();
				}
			}
		},

		onRemoveContextDrill: function(event) {
			event.stopPropagation();
			//The data-id attribute holds the drill collection model id for the drill model to be deleted
			var drillToDelete = this._getDrillId(event);
			if (drillToDelete) {

				const dataItem = this.visualization.getSlots().getDataItem(drillToDelete);
				const transactionToken = this.transaction.startTransaction();
				dataItem.clearDrill(transactionToken);

				this.visAPI.getLocalFilters().removeFilterEntry({
					id: dataItem.getColumnId()
				});

				this.visAPI.getLocalFilters().allFilterModificationComplete(TransactionUtil.transactionTokenToOptions(transactionToken));

				this.transaction.endTransaction(transactionToken);
				this.popupParent.close();
			}
		},

		/**
		 * edits the selected topbottom if exists
		 */
		onEditContextTopBottom: function(event) {
			event.stopPropagation();
			//The data-id attribute holds the filter collection model id for the filters model to be edited
			var topBottomToEdit = this._getTopBottomId(event);
			var node = $(event.target).parents('.topBottomEntry')[0] || $(event.target)[0];
			let result;
			if (topBottomToEdit) {
				const mappingInfo = this.visualization.getSlots().getMappingInfo(topBottomToEdit);
				var slot = mappingInfo.slot;
				var index = mappingInfo.indexInSlot;

				if (slot && index >= 0) {
					result = this.visController
						.getActionHelper()
						.showAction('topBottomAction', slot, node, index)
						.then((editor) => {
							if (editor) {
								this.popupParent.detachHideEvents(); // stay visible while editor active
								this.parentListClass = '.topBottomList';
							}
						});
				} else {
					result = Promise.resolve();
				}
			} else {
				result = Promise.resolve();
			}
			return result;
		},

		_getDrillId: function(event) {
			var drillEntry = $(event.target).parents('.drillStateEntry')[0] || $(event.target)[0];
			if (drillEntry) {
				return drillEntry.getAttribute('data-id');
			}
			return null;
		},

		_getTopBottomId: function(event) {
			var topBottomEntry = $(event.target).parents('.topBottomEntry')[0] || $(event.target)[0];
			if (topBottomEntry) {
				return topBottomEntry.getAttribute('data-id');
			}
			return null;
		},

		_generatePromptListItems: function(oPromptSpec, aListItems) {
			for (var sPromptName in oPromptSpec) {
				if (oPromptSpec.hasOwnProperty(sPromptName)) {
					var oPromptInfo = oPromptSpec[sPromptName];
					var sPromptValue = this._filterLabelHelper.getPromptLabel(oPromptInfo);
					var line = {
						'type': 'prompt',
						'deleteEnabled': false,
						'editEnabled': true,
						'extraEditEnabled': true,
						'dataId': oPromptInfo.name,
						'title': oPromptInfo.name,
						'description': sPromptValue,
						'toolTip': sPromptValue,
						'svgHref': '#common-filter',
						'editLabel': stringResources.get('editFilter'),
						'ariaEditLabel': stringResources.get('ariaEditPrompt')
					};

					aListItems.push(line);
				}
			}
		},

		_generateDrillStateListItems: function(drillStates, aListItems) {
			_.each(drillStates, function(drillState) {
				var line = {};
				var drillStateDescription = this._getDrillStateDescription(drillState);
				if (drillState.columnId !== undefined || drillState.columnLabel !== undefined) {
					if (!drillStateDescription) {
						return;
					}
					line = drillStateDescription;
				}
				if (drillState.id) {
					line.deleteEnabled = drillState.deleteEnabled;
					line.editEnabled = drillState.editEnabled;
					line.dataId = drillState.id;
					line.deleteLabel = stringResources.get('deleteTopBottom');
					line.ariaDeleteLabel = stringResources.get('ariaDeleteDrillStateLabel');
				}
				line.type = 'drillState';
				aListItems.push(line);

			}.bind(this));
		},

		_getDrillStateDescription: function(drillState){
			if(drillState.columnId !== undefined){
				var columnMetaData = this._filterLabelHelper.getColumnMetadataNameFromColumnId(drillState.columnId);
				if (!columnMetaData) {
					return null;
				}
				drillState.columnLabel = columnMetaData.getLabel();

				return this._getDrillStateLabel(drillState, columnMetaData);
			}
		},

		_getDrillStateLabel: function(drillState){

			var line;
			var drillDesc;

			if(drillState.children){
				drillState.operator = 'in';
				drillState.values = [{ d:drillState.columnLabel, u:drillState.children }];
				drillDesc = this._filterLabelHelper.getFilterDescription(drillState);

				line = {
					title: stringResources.get('drillDownStateTitle'),
					description: drillDesc,
					toolTip: drillDesc
				};
			} else if(drillState.drillUp){
				drillState.operator = 'in';
				drillState.values = [{ d:drillState.columnLabel, u:drillState.drillUp }];
				drillDesc = this._filterLabelHelper.getFilterDescription(drillState);

				line = {
					title: stringResources.get('drillUpStateTitle'),
					description: drillDesc,
					toolTip: drillDesc
				};
			}

			return line;
		}

	});
	return FilterFlyoutView;
});
